import { useEffect } from "react"
import { PulseLoader } from "react-spinners"
import { getDownloadURL, ref } from "firebase/storage"
import { runInAction } from "mobx"
import { observer, useLocalObservable } from "mobx-react-lite"
import { storage } from "../../firebaseApp"

interface IImageProps {
	url: string | null
	width: number
	height: number
}

export const Image = observer(({ url, width, height }: IImageProps) => {
	const store = useLocalObservable(() => ({
		url: null as string | null,
		downloadUrl: null as string | null,

		async load(url: string | null) {
			if (!url) return
			if (url === this.url) {
				return
			} else {
				this.url = url
			}

			if (this.url.startsWith("http")) {
				runInAction(() => {
					this.downloadUrl = this.url
				})
				return
			}

			const imageRef = ref(storage, this.url)
			let downloadUrl: string

			try {
				downloadUrl = await getDownloadURL(imageRef)
			} catch {
				console.log(`Invalid image url provided in Image - '${this.url ?? "undefined"}'`)
			}

			runInAction(() => {
				this.downloadUrl = downloadUrl
			})
		},
	}))

	useEffect(() => {
		store.load(url)
	}, [url, store])

	const content = () => {
		if (store.downloadUrl) {
			return <img className={`h-[${height}px] w-[${width}px] object-cover`} src={store.downloadUrl} />
		}

		return <PulseLoader color="white" size={`${Math.min(width, height) / 20}px`} />
	}

	return <div className={`w-[${width}px] h-[${height}px] flex items-center justify-center`}>{content()}</div>
})
